import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { PlannerV2_GetPendingChangesDocument } from "../queries.generated";

export default function usePlannerV2AreasGetWithPendingChanges() {
    const { data: latestData, previousData } = useQuery(PlannerV2_GetPendingChangesDocument, {
        fetchPolicy: "cache-first",
    });

    const data = latestData ?? previousData;

    const totalDrafts = useMemo(() => {
        const areasToBePlanned = data?.plannerV2AreasGetWithPendingChanges.toBePlanned ?? [];
        const areasToBeCancelled = data?.plannerV2AreasGetWithPendingChanges.toBeCancelled ?? [];

        const numberOfVisitsToBePlanned = areasToBePlanned.reduce((sum, area) => sum + area.plannerVisits.length, 0);
        const numberOfVisitsToBeCancelled = areasToBeCancelled.reduce(
            (sum, area) => sum + area.plannerVisits.length,
            0,
        );

        return numberOfVisitsToBePlanned + numberOfVisitsToBeCancelled;
    }, [data]);

    return {
        totalDrafts,
    };
}
